import React from 'react';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import useSharedIsMenuOpen from './IsMenuOpen';
import CloseIcon from '@mui/icons-material/Close';
import { HeaderTheme } from './HeaderTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import useSharedDocHeader from './DocHeaderHook';

export default function MobileMenu(props) {
  const {isMenuOpen,doHideMenu} = useSharedIsMenuOpen();
  const {routerId} = useSharedDocHeader();
  const { t,i18n } = useTranslation(['categoryLabel', 'common']);
  let navigate = useNavigate();

  const closeMenu  = () => {
    doHideMenu();
  }

  const handleClick = (event) => {
    navigate(event.currentTarget.id, { replace: false });
    doHideMenu();
  };

  const drawerWidth = 150;

   /* handler for language change */
   const handleLangChange = (event) => {
    i18n.changeLanguage(event.target.value);
    doHideMenu();
  };

  const handleDrawerClose = (ev,reason) => {
    doHideMenu();
  };

  return (
    <ThemeProvider theme={HeaderTheme}>
        <Drawer
          variant="temporary"
          open={isMenuOpen}
          onClose={handleDrawerClose}
          sx={{
            display: { sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          
            <IconButton sx={{mb: 0,justifyContent:'left'}} onClick={closeMenu}>
              <CloseIcon/>
            </IconButton>
            <Box sx={{paddingBottom:3,justifyContents:'start'}}>
              <FormControl variant="standard">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={i18n.language}
                  onChange={handleLangChange}
                  sx={{border:'none'}}
                >
                  <MenuItem value={'de'}>Deutsch</MenuItem>
                  <MenuItem value={'en'}>English</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Stack sx={{display:'flex',alignItems:'flex-start',justifyContent:'flex-start'}}>
              {props.pages.map((page) => (
                <Button
                  key={page.key}
                  id={page.id}
                  sx={{ my: 0, color: 'black', fontWeight:(page.id===routerId)?'700':'500'}}
                  onClick={handleClick}
                >
                  {t(page.key)}
                </Button>
              ))}
            </Stack>
        </Drawer>
    </ThemeProvider>
  )
}
